var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromocodeNotActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.031,
    height: 25.042,
    viewBox: "0 0 25.031 25.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(-0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "translate(7.33 11.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M148.619,229.206a1.811,1.811,0,1,0,1.475,1.78A1.651,1.651,0,0,0,148.619,229.206Zm0,2.826c-.4,0-.742-.479-.742-1.046s.34-1.046.742-1.046.742.479.742,1.046S149.021,232.032,148.619,232.032Z",
    transform: "translate(-147.144 -229.206)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(15.024 11.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M305.912,229.207a1.811,1.811,0,1,0,1.475,1.78A1.651,1.651,0,0,0,305.912,229.207Zm0,2.826c-.4,0-.742-.479-.742-1.046s.34-1.046.742-1.046.742.479.742,1.046S306.314,232.033,305.912,232.033Z",
    transform: "translate(-304.437 -229.207)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(9.796 16.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M203.242,339.349a3.1,3.1,0,0,0-5.646,0,.367.367,0,0,0,.668.3,2.369,2.369,0,0,1,4.309,0,.367.367,0,1,0,.668-.3Z",
    transform: "translate(-197.563 -337.533)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(15.621 8.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M319.755,181.566a3.848,3.848,0,0,0-2.744-1.105.367.367,0,0,0,.015.733,3.126,3.126,0,0,1,2.222.9.367.367,0,1,0,.507-.53Z",
    transform: "translate(-316.651 -180.46)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    transform: "translate(6.465 8.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M132.334,180.46a3.845,3.845,0,0,0-2.744,1.105.367.367,0,1,0,.507.53,3.132,3.132,0,0,1,2.163-.9h.067a.367.367,0,0,0,.007-.733Z",
    transform: "translate(-129.477 -180.459)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    transform: "translate(4.633 15.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M96.228,313.405l-.158-.316a.367.367,0,1,0-.656.328l.152.3a1.488,1.488,0,0,1-1.4,2.051,1.437,1.437,0,0,1-1.287-2.028l1.4-2.594.364.727a.367.367,0,1,0,.656-.328l-.391-.783a.7.7,0,0,0-.616-.388h-.011a.7.7,0,0,0-.617.368c-1.524,2.817-1.44,2.66-1.449,2.681a2.172,2.172,0,0,0,1.975,3.078A2.223,2.223,0,0,0,96.228,313.405Z",
    transform: "translate(-92.016 -310.38)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(5.394 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M125.63,6.262a12.511,12.511,0,0,0-17.939-4.05.367.367,0,1,0,.415.6A11.784,11.784,0,0,1,122.6,21.346a.367.367,0,1,0,.486.55A12.526,12.526,0,0,0,125.63,6.262Z",
    transform: "translate(-107.532 0)",
    fill: "#dd1010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "translate(0.139 3.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M19.647,84.967a.367.367,0,0,0-.508-.1c-.2.133-.4.258-.6.37A11.784,11.784,0,0,1,4.667,66.359a.367.367,0,1,0-.5-.54A12.517,12.517,0,0,0,19.542,85.475.367.367,0,0,0,19.647,84.967Z",
    transform: "translate(-0.139 -65.722)",
    fill: "#dd1010"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocodeNotActive);
export default __webpack_public_path__ + "static/media/promocode_not_active.d0839f978c61e9ae83eb5fdbf7058aa1.svg";
export { ForwardRef as ReactComponent };